import React, { useState } from "react";

const WarrantyApproval = () => {
  const [list, setList] = useState([
    {
      id: 1,
      sino: "SN-001",
      modelno: "MOD-X100",
      email: "john@example.com",
      mobileno: "9876543210",
      inv_date: "2026-05-10",
      dealercode: "DLR-001",
      inv_copy: "invoice_001.pdf",
      warrantycard: "warranty_001.pdf",
      status: "Pending",
    },
    {
      id: 2,
      sino: "SN-002",
      modelno: "MOD-X200",
      email: "jane@example.com",
      mobileno: "9876543211",
      inv_date: "2026-05-12",
      dealercode: "DLR-002",
      inv_copy: "invoice_002.pdf",
      warrantycard: "warranty_002.pdf",
      status: "Pending",
    },
    {
      id: 3,
      sino: "SN-003",
      modelno: "MOD-X300",
      email: "bob@example.com",
      mobileno: "9876543212",
      inv_date: "2026-05-15",
      dealercode: "DLR-003",
      inv_copy: "invoice_003.pdf",
      warrantycard: "warranty_003.pdf",
      status: "Pending",
    },
    {
      id: 4,
      sino: "SN-004",
      modelno: "MOD-X400",
      email: "alice@example.com",
      mobileno: "9876543213",
      inv_date: "2026-05-18",
      dealercode: "DLR-004",
      inv_copy: "invoice_004.pdf",
      warrantycard: "warranty_004.pdf",
      status: "Pending",
    },
  ]);

  const handleApprove = async (item) => {
    const payload = new FormData();
    payload.append("sino", item.sino);
    payload.append("modelno", item.modelno);
    payload.append("email", item.email);
    payload.append("mobileno", item.mobileno);
    payload.append("inv_date", item.inv_date);
    payload.append("dealercode", item.dealercode);

    console.log("Approval Payload:");
    for (let pair of payload.entries()) {
      console.log(pair[0], pair[1]);
    }

    // API CALL
    // await axios.post("/warranty-approval/", payload, {
    //   headers: { "Content-Type": "multipart/form-data" },
    // });

    setList((prev) =>
      prev.map((i) =>
        i.id === item.id ? { ...i, status: "Approved" } : i
      )
    );
    alert(`Warranty for ${item.sino} approved successfully`);
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div
          className="card-header text-white text-center"
          style={{ backgroundColor: "#005b8f" }}
        >
          <h2 className="mb-0">Warranty Approval</h2>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-dark">
                <tr>
                  <th>S.No</th>
                  <th>Serial Number</th>
                  <th>Model Number</th>
                  <th>Email</th>
                  <th>Mobile Number</th>
                  <th>Invoice Date</th>
                  <th>Dealer Code</th>
                  <th>Invoice Copy</th>
                  <th>Warranty Card</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.sino}</td>
                    <td>{item.modelno}</td>
                    <td>{item.email}</td>
                    <td>{item.mobileno}</td>
                    <td>{item.inv_date}</td>
                    <td>{item.dealercode}</td>
                    <td>
                      <a href="#" className="text-primary">
                        {item.inv_copy}
                      </a>
                    </td>
                    <td>
                      <a href="#" className="text-success">
                        {item.warrantycard}
                      </a>
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          item.status === "Approved"
                            ? "bg-success"
                            : "bg-warning text-dark"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>
                      {item.status === "Pending" ? (
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => handleApprove(item)}
                        >
                          Approve
                        </button>
                      ) : (
                        <span className="text-muted">Done</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarrantyApproval;